export const statusColors = {
  draft: 'bg-gray-500',
  submitted: 'bg-blue-500',
  under_review: 'bg-yellow-500',
  revision_requested: 'bg-orange-500',
  pic_approved: 'bg-cyan-500',
  admin_approved: 'bg-indigo-500',
  approved: 'bg-green-500',
  approved_pending_fund: 'bg-amber-500',
  developer_funded: 'bg-teal-500',
  partially_paid: 'bg-sky-500',
  fully_paid: 'bg-emerald-600',
  paid: 'bg-emerald-600',
  rejected: 'bg-red-500',
};

export const statusLabels = {
  draft: 'Draft',
  submitted: 'Submitted',
  under_review: 'Under Review',
  revision_requested: 'Revision Requested',
  pic_approved: 'PIC Approved',
  admin_approved: 'Admin Approved',
  approved: 'Fully Approved',
  approved_pending_fund: 'Awaiting Dev Payment',
  developer_funded: 'Developer Funded',
  partially_paid: 'Partially Paid',
  fully_paid: 'Fully Paid',
  paid: 'Paid',
  rejected: 'Rejected',
};
